import React, { useState, useEffect } from 'react';
import shuffle from 'lodash/shuffle';
import CommonLoanPurpose from './CommonLoanPurpose';
import styles from './Loan.module.css';
import { useFormikContext } from 'formik';
import { getPropertyDetailsApi } from '../../../../common/constants/api';
import Modal from '../../../../common/components/Modal/modal';
import MbBottomModal from '../../../../common/components/MbBottomModal/MbBottomModal';
import CommonModalPropertyType from './CommonModalPropertyType';
import MbCommonModalPropertyType from './MbCommonModalPropertyType';
import flat_icon from '../../../../images/icons/UserKycIcons/flat_icon.svg';
import villa_icon from '../../../../images/icons/UserKycIcons/villa_icon.svg';
import independentHouse from '../../../../images/icons/UserKycIcons/independentHouse.svg';
import plot_icon from '../../../../images/icons/UserKycIcons/plot_icon.svg';

import PopUp from '../../../../common/components/PopUp/PopUp';
import { getLeadProertyDetails } from '../../../../common/constants/api';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';

let bgAndTextColors = [
  {
    bgcolor: '#e8f8f5',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#e9ecf9',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#f9ecf9',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#eef6e3',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#fcf6e6',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#f1ecf8',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#e8f8f1',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#fcf6e6',
    textcolor: '#48545E'
  },
  {
    bgcolor: '#fad4db',
    textcolor: '#48545E'
  }
];

const TestDataForModal = {
  threeOptions: [
    { id: '1', displayName: 'Flat', imgUrl: flat_icon },
    { id: '2', displayName: 'Villa', imgUrl: villa_icon },
    { id: '3', displayName: 'Independent House', imgUrl: independentHouse }
  ],
  fourOptions: [
    { id: '1', displayName: 'Flat', imgUrl: flat_icon },
    { id: '2', displayName: 'Villa', imgUrl: villa_icon },
    { id: '3', displayName: 'Independent House', imgUrl: independentHouse },
    { id: '4', displayName: 'Plot', imgUrl: plot_icon }
  ]
};

function PropertyDetails() {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [activeLoanType, setActiveLoanType] = useState('');
  const [Loading, setLoading] = useState(false);
  const [LoadingFail, setLoadingFail] = useState(false);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);

  useEffect(() => {
    setLoading(true);
    getPropertyDetailsApi()
      .then(res => {
        setData(res);
        setLoading(false);
      })
      .catch(err => {
        setLoading(true);
        setLoadingFail(true);
      });
  }, []);

  // get API

  useEffect(() => {
    getLeadProertyDetails(leadId)
      .then(res => {
        setFieldValue('typeOfProperty', res?.propertyType);
        setFieldValue('loneTypeID', res?.productId);
      })
      .catch(err => {
        setLoading(true);
        setLoadingFail(true);
      });
  }, [leadId]);
  const { Loan_Details_box, modalContainer, Modaltext } = styles;
  const { values, handleSubmit, setFieldValue } = useFormikContext();
  const { loneTypeID, typeOfProperty } = values;

  function handleSelectData(anyselected) {
    setFieldValue('loanType', anyselected.displayName);
    setFieldValue('loneTypeID', anyselected.id);
    if (anyselected.id === 7 || anyselected.id === 8) {
      handleSubmit();
    }
  }
  function selectPropertyType(anyselected) {
    setFieldValue('typeOfPropertyId', anyselected.id);
    setFieldValue('iconTypeOfProperty', anyselected.imgUrl);
    setFieldValue('typeOfProperty', anyselected.displayName);
    handleSubmit();
  }

  bgAndTextColors = shuffle(bgAndTextColors);

  let finalModalData = null;
  if (loneTypeID === 11) {
    finalModalData = TestDataForModal.threeOptions;
  }
  if (loneTypeID === 10 || loneTypeID === 3 || loneTypeID === 6) {
    finalModalData = TestDataForModal.fourOptions;
  }

  return (
    <React.Fragment>
      {/* //// */}
      {Loading && (
        <PopUp
          autoClose={false}
          type={LoadingFail ? 'fail' : 'loading'}
          text={
            LoadingFail
              ? 'Oops! something went wrong, please try again..'
              : 'Loading...'
          }
          show={Loading}
          setShow={setLoading}
        />
      )}
      {/* //// */}

      <div>
        <h1 className="font-roboto font-medium text-base text-black-850 mt-10 pl-2">
          Choose Loan Purpose
        </h1>
        <div
          className={`${Loan_Details_box} md:bg-white  m-2 md:mx-auto p-4 pb-8 pt-6 lg:pl-12 lg:pr-40`}
        >
          {data &&
            data.map((each, index) => {
              return (
                <CommonLoanPurpose
                  loneTypeID={loneTypeID}
                  key={each.id}
                  id={each.id}
                  sendUrl={each.imgUrl}
                  sendloanType={each.displayName}
                  randomColor={bgAndTextColors[index]}
                  handleSelectData={() => {
                    setActiveLoanType(each.displayName);
                    handleSelectData(each);
                  }}
                  setShow={setShow}
                />
              );
            })}

          {show && (
            <div className="hidden md:block">
              <Modal
                show={show}
                setShow={setShow}
                styleContainer={{
                  width: '395px'
                }}
              >
                <div
                  className={`${Modaltext} text-grey-920 text-base font-roboto font-medium`}
                >
                  {activeLoanType}
                </div>
                <div
                  style={{
                    borderBottom: '1px solid #DCE9F5',
                    position: 'relative',
                    top: '-15px'
                  }}
                ></div>
                {/* //need to add here */}
                {finalModalData ? (
                  <div className={`${modalContainer} my-5`}>
                    {finalModalData.map((each, index) => {
                      return (
                        <CommonModalPropertyType
                          typeOfProperty={typeOfProperty}
                          key={each.id}
                          sendUrl={each.imgUrl}
                          sendloanType={each.displayName}
                          selectPropertyType={() => {
                            selectPropertyType(each);
                          }}
                          setShow={setShow}
                        />
                      );
                    })}
                  </div>
                ) : (
                  <h1 className="text-center text-base font-roboto text-black-400 p-5">
                    Coming Soon
                  </h1>
                )}

                {/* ///end need to add here */}
              </Modal>
            </div>
          )}

          {/* ////testing */}

          <div className="md:hidden">
            <MbBottomModal show={show} setShow={setShow}>
              <div
                className={`${Modaltext} text-grey-920 text-base font-roboto font-medium`}
              >
                {activeLoanType}
              </div>
              <div
                style={{
                  borderBottom: '1px solid #DCE9F5',
                  position: 'relative',
                  top: '-15px'
                }}
              ></div>
              {finalModalData ? (
                <div className={` my-5`}>
                  {finalModalData.map((each, index) => {
                    return (
                      <MbCommonModalPropertyType
                        typeOfProperty={typeOfProperty}
                        key={each.id}
                        sendUrl={each.imgUrl}
                        sendloanType={each.displayName}
                        selectPropertyType={() => {
                          selectPropertyType(each);
                        }}
                        setShow={setShow}
                      />
                    );
                  })}
                </div>
              ) : (
                <h1 className="text-center text-base font-roboto text-black-400 p-5">
                  Coming Soon
                </h1>
              )}
            </MbBottomModal>
          </div>

          {/* testing */}
        </div>
      </div>
    </React.Fragment>
  );
}
export default PropertyDetails;
